// test1658
(1658 && 0);
